import React from 'react';
import PageTopComp from '../../../core/components/PageTop';

const PageReportBiKpi = (): JSX.Element => {
    // tbd: init the page (runs once)
    return (
        <>
            <PageTopComp
                title="Insights KPI Reports"
                icon="sprite-guage"
            />
            <div className="bi-feature bi-kpi">
                <Content />
            </div>
        </>
    );
};

const Content = (): JSX.Element => {
    // tbd: load page hook, wait for state.init false
    return <Welcome />;
};

const Welcome = (): JSX.Element => {
    const title = 'Welcome to Insights KPI';
    return (
        <div className="bi-welcome">
            <h3>{title}</h3>
            <p>&nbsp;</p>
            <p>Here you can find various KPIs related to the performance of the system.</p>
            <img
                className="bi-welcome-img"
                src="/assets/img/app/dash-graph.png"
            />
            <p className="bi-welcome-data-note">Insights includes this current year and 5 year historical data.</p>
        </div>
    );
};

export default PageReportBiKpi;
